import locales from './modules/_locales';
import queries from './modules/_queries';
import toast from './modules/_toast';
import utils from './modules/_utils';
import vault from './modules/_vault';
import { settings, colors } from './modules/_settings';
import { http, lambda } from './modules/_axios';


export default {
	install(Vue, store) {
		Vue.prototype.$http = http; // Axios General
		Vue.prototype.$lambda = lambda; //Axios Lambda

		Vue.prototype.$query = queries(store); // View options
		Vue.prototype.$vault = vault(store); // Vault
		Vue.prototype.$toast = toast(); // Toast notifications
		Vue.prototype.$utils = utils(); // Helpers

		Vue.prototype.$settings = settings(store); // Settings
		Vue.prototype.$colors = colors; // Colors
		Vue.prototype.$locale = locales; // Locales
		Vue.prototype.$env = process.env; // Locales
	}
}
